// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__64Xk7","icon":"styles_icon__XOwif","content":"styles_content__Bwpq0","closeButton":"styles_closeButton__zYdhQ"};